/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Address } from './Address.js';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address.js';
import type { ContactParticipation } from './ContactParticipation.js';
import {
    ContactParticipationFromJSON,
    ContactParticipationFromJSONTyped,
    ContactParticipationToJSON,
} from './ContactParticipation.js';
import type { ContactScript } from './ContactScript.js';
import {
    ContactScriptFromJSON,
    ContactScriptFromJSONTyped,
    ContactScriptToJSON,
} from './ContactScript.js';
import type { ContactStatus } from './ContactStatus.js';
import {
    ContactStatusFromJSON,
    ContactStatusFromJSONTyped,
    ContactStatusToJSON,
} from './ContactStatus.js';
import type { ContactWeather } from './ContactWeather.js';
import {
    ContactWeatherFromJSON,
    ContactWeatherFromJSONTyped,
    ContactWeatherToJSON,
} from './ContactWeather.js';
import type { Flag } from './Flag.js';
import {
    FlagFromJSON,
    FlagFromJSONTyped,
    FlagToJSON,
} from './Flag.js';

/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {number}
     * @memberof Contact
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Contact
     */
    customerId?: number;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    customerPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    systemPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    isInbound?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    locale?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    timezone?: string;
    /**
     * 
     * @type {ContactWeather}
     * @memberof Contact
     */
    weather?: ContactWeather;
    /**
     * 
     * @type {Address}
     * @memberof Contact
     */
    address?: Address;
    /**
     * 
     * @type {Array<ContactStatus>}
     * @memberof Contact
     */
    statusHistory?: Array<ContactStatus>;
    /**
     * 
     * @type {ContactScript}
     * @memberof Contact
     */
    script?: ContactScript;
    /**
     * 
     * @type {Array<ContactParticipation>}
     * @memberof Contact
     */
    participations?: Array<ContactParticipation>;
    /**
     * 
     * @type {Array<Flag>}
     * @memberof Contact
     */
    flags?: Array<Flag>;
}

/**
 * Check if a given object implements the Contact interface.
 */
export function instanceOfContact(value: object): boolean {
    return true;
}

export function ContactFromJSON(json: any): Contact {
    return ContactFromJSONTyped(json, false);
}

export function ContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): Contact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'customerPhoneNumber': json['customerPhoneNumber'] == null ? undefined : json['customerPhoneNumber'],
        'systemPhoneNumber': json['systemPhoneNumber'] == null ? undefined : json['systemPhoneNumber'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'isInbound': json['isInbound'] == null ? undefined : json['isInbound'],
        'locale': json['locale'] == null ? undefined : json['locale'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'weather': json['weather'] == null ? undefined : ContactWeatherFromJSON(json['weather']),
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'statusHistory': json['statusHistory'] == null ? undefined : ((json['statusHistory'] as Array<any>).map(ContactStatusFromJSON)),
        'script': json['script'] == null ? undefined : ContactScriptFromJSON(json['script']),
        'participations': json['participations'] == null ? undefined : ((json['participations'] as Array<any>).map(ContactParticipationFromJSON)),
        'flags': json['flags'] == null ? undefined : ((json['flags'] as Array<any>).map(FlagFromJSON)),
    };
}

export function ContactToJSON(value?: Contact | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'customerId': value['customerId'],
        'sourceId': value['sourceId'],
        'customerPhoneNumber': value['customerPhoneNumber'],
        'systemPhoneNumber': value['systemPhoneNumber'],
        'summary': value['summary'],
        'isInbound': value['isInbound'],
        'locale': value['locale'],
        'timezone': value['timezone'],
        'weather': ContactWeatherToJSON(value['weather']),
        'address': AddressToJSON(value['address']),
        'statusHistory': value['statusHistory'] == null ? undefined : ((value['statusHistory'] as Array<any>).map(ContactStatusToJSON)),
        'script': ContactScriptToJSON(value['script']),
        'participations': value['participations'] == null ? undefined : ((value['participations'] as Array<any>).map(ContactParticipationToJSON)),
        'flags': value['flags'] == null ? undefined : ((value['flags'] as Array<any>).map(FlagToJSON)),
    };
}

